// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ejUVp","colMin":"styles_colMin__1WTIy"};